let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("LtnWn")).then(() => parcelRequire('8y0gw'));